import { omit } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './EditableText.scss';
import Textarea from 'react-textarea-autosize';

class EditableText extends Component {
  static propTypes = {
    autoHeight: PropTypes.bool,
    onKeyDown: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    fluid: PropTypes.bool,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    update: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
    this.reset = this.reset.bind(this);
    this.state = {
      value: this.props.value
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: nextProps.value });
    }
  }

  onChange(e) {
    this.setState({ value: e.target.value.replace('\n', '') });
    if (this.props.onChange) this.props.onChange(e);
  }

  onBlur() {
    this.update();
    if (this.props.onBlur) this.props.onBlur();
  }

  onKeyDown(e) {
    if (e.key === 'Enter') {
      this.update();
    } else if (e.key === 'Escape') {
      e.stopPropagation();
      this.reset(() => this.textarea.blur());
    }
    if (this.props.onKeyDown) this.props.onKeyDown(e);
  }

  onSuccess() {
    if (this.textarea) this.textarea.blur();
  }

  onError() {
    if (this.textarea) this.textarea.focus();
  }

  reset(callback) {
    this.setState({ value: this.props.value }, callback);
  }

  update() {
    if (this.props.update && this.props.value !== this.state.value) {
      this.props.update(
        { value: this.state.value, name: this.props.name },
        this.onSuccess,
        this.onError
      );
    }
  }

  render() {
    const { autoHeight, className, fluid, ...rest } = omit(this.props, [
      'value',
      'update',
      'onChange',
      'onBlur',
      'onKeyDown'
    ]);
    const TextArea = (
      <Textarea
        onChange={this.onChange}
        onBlur={this.onBlur}
        className={[className, styles.input, fluid ? styles.fluid : null].join(
          ' '
        )}
        value={this.state.value ? `${this.state.value}` : ''}
        onKeyDown={this.onKeyDown}
        inputRef={tag => (this.textarea = tag)}
        {...rest}
      />
    );
    const Input = (
      <input
        onChange={this.onChange}
        onBlur={this.onBlur}
        className={[className, styles.input, fluid ? styles.fluid : null].join(
          ' '
        )}
        value={this.state.value || ''}
        onKeyDown={this.onKeyDown}
        ref={tag => (this.textarea = tag)}
        {...rest}
      />
    );
    return autoHeight ? TextArea : Input;
  }
}

export default EditableText;



// WEBPACK FOOTER //
// ./webpack/components/Elements/EditableText/index.js